import { ApplicationsState } from '@/state'
import { applicationsStateActions } from '@/state/actions'
import { Modal } from 'antd'
import ImportDetails from './details'
import ImportTypeChooser from './typeChooser'
import ImportFileAttach from './fileAttach'

import './modal.scss'
import DownloadImportTemplate from './downloadPlantilla'

export default function ImportModal() {
  return (
    <Modal
      className='import-modal'
      title={`Importar data para convocatoria`}
      open={ApplicationsState.openImportModal.value}
      onCancel={applicationsStateActions.closeImportModal}
      footer={null}
      style={{ padding: 0 }}
      maskClosable={!ApplicationsState.loading.value.import}
      closable={!ApplicationsState.loading.value.import}
      destroyOnHidden
    >
      <ImportDetails />
      <ImportTypeChooser />
      <ImportFileAttach />
      <DownloadImportTemplate />
    </Modal>
  )
}
